import {
  clamp
} from "./chunk.JQVCVYYC.js";
import {
  i2 as i22
} from "./chunk.XPDKWWJW.js";
import {
  focusVisibleSelector
} from "./chunk.6JE2K3D5.js";
import {
  emit
} from "./chunk.T3VOOO5F.js";
import {
  watch
} from "./chunk.H7XADNZ7.js";
import {
  e,
  i2,
  n
} from "./chunk.5E26GMTR.js";
import {
  $,
  component_styles_default,
  r,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.J4R5E6TY.js
var image_comparer_styles_default = r` ${component_styles_default} :host { --divider-width: 2px; --handle-size: 2.5rem; display: inline-block; position: relative; } .image-comparer { max-width: 100%; max-height: 100%; overflow: hidden; } .image-comparer__before, .image-comparer__after { pointer-events: none; } .image-comparer__before ::slotted(img), .image-comparer__after ::slotted(img), .image-comparer__before ::slotted(svg), .image-comparer__after ::slotted(svg) { display: block; max-width: 100% !important; height: auto; } .image-comparer__after { position: absolute; top: 0; left: 0; height: 100%; width: 100%; } .image-comparer__divider { display: flex; align-items: center; justify-content: center; position: absolute; top: 0; width: var(--divider-width); height: 100%; background-color: var(--sl-color-neutral-0); transform: translateX(calc(var(--divider-width) / -2)); cursor: ew-resize; } .image-comparer__handle { display: flex; align-items: center; justify-content: center; position: absolute; top: calc(50% - (var(--handle-size) / 2)); width: var(--handle-size); height: var(--handle-size); background-color: var(--sl-color-neutral-0); border-radius: var(--sl-border-radius-circle); font-size: calc(var(--handle-size) * 0.5); color: var(--sl-color-neutral-600); cursor: inherit; z-index: 10; } .image-comparer__handle${focusVisibleSelector} { outline: none; box-shadow: var(--sl-focus-ring); } `;

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.RBICTPSA.js
function drag(container, onMove) {
  function move(pointerEvent) {
    const dims = container.getBoundingClientRect();
    const defaultView = container.ownerDocument.defaultView;
    const offsetX = dims.left + defaultView.pageXOffset;
    const offsetY = dims.top + defaultView.pageYOffset;
    const x = pointerEvent.pageX - offsetX;
    const y = pointerEvent.pageY - offsetY;
    onMove(x, y);
  }
  function stop() {
    document.removeEventListener("pointermove", move);
    document.removeEventListener("pointerup", stop);
  }
  document.addEventListener("pointermove", move, { passive: true });
  document.addEventListener("pointerup", stop);
}

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.227CWEC6.js
var SlImageComparer = class extends s4 {
  constructor() {
    super(...arguments);
    this.position = 50;
  }
  handleDrag(event) {
    const { width } = this.base.getBoundingClientRect();
    event.preventDefault();
    drag(this.base, (x) => {
      this.position = parseFloat(clamp(x / width * 100, 0, 100).toFixed(2));
    });
  }
  handleKeyDown(event) {
    if (["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
      const incr = event.shiftKey ? 10 : 1;
      let newPosition = this.position;
      event.preventDefault();
      if (event.key === "ArrowLeft") {
        newPosition -= incr;
      }
      if (event.key === "ArrowRight") {
        newPosition += incr;
      }
      if (event.key === "Home") {
        newPosition = 0;
      }
      if (event.key === "End") {
        newPosition = 100;
      }
      newPosition = clamp(newPosition, 0, 100);
      this.position = newPosition;
    }
  }
  handlePositionChange() {
    emit(this, "sl-change");
  }
  render() {
    return $`<div part="base" id="image-comparer" class="image-comparer" @keydown=${this.handleKeyDown}><div class="image-comparer__image"><div part="before" class="image-comparer__before"><slot name="before"></slot></div><div part="after" class="image-comparer__after" style=${i22({ clipPath: `inset(0 ${100 - this.position}% 0 0)` })} ><slot name="after"></slot></div></div><div part="divider" class="image-comparer__divider" style=${i22({ left: `${this.position}%` })} @mousedown=${this.handleDrag} @touchstart=${this.handleDrag} ><div part="handle" class="image-comparer__handle" role="scrollbar" aria-valuenow=${this.position} aria-valuemin="0" aria-valuemax="100" aria-controls="image-comparer" tabindex="0" ><slot name="handle-icon"><sl-icon class="image-comparer__handle-icon" name="grip-vertical" library="system"></sl-icon></slot></div></div></div>`;
  }
};
SlImageComparer.styles = image_comparer_styles_default;
__decorateClass([
  i2(".image-comparer")
], SlImageComparer.prototype, "base", 2);
__decorateClass([
  i2(".image-comparer__handle")
], SlImageComparer.prototype, "handle", 2);
__decorateClass([
  e({ type: Number, reflect: true })
], SlImageComparer.prototype, "position", 2);
__decorateClass([
  watch("position", { waitUntilFirstUpdate: true })
], SlImageComparer.prototype, "handlePositionChange", 1);
SlImageComparer = __decorateClass([
  n("sl-image-comparer")
], SlImageComparer);

export {
  drag,
  SlImageComparer
};
